import {
  availableConversationSettingsTools,
  ConversationEntityVariant,
  ConversationSettingsConfig,
  requiredToolsConfig,
} from '@procureai/agents';

const requiredTools = requiredToolsConfig[ConversationEntityVariant.DEMAND];

export const defaultConversationSettings: ConversationSettingsConfig = {
  tools: availableConversationSettingsTools.map((toolId) => ({
    id: toolId,
    isEnabled: requiredTools[toolId],
  })),
  quickActions: [],
  description: '',
};
